angular.module('TeacherControllers')

  .controller('TeacherStudentsHomeCtrl', ['$scope', 'api', 'EXAM', '$mdDialog', 'exam', function($scope, api, EXAM, $mdDialog, exam) {

  }
  ]);
